import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import SubTable from './SubTable'
import Pagination from '../Pagination'
import dayjs from 'dayjs'
import SubAdminView from './SubAdminView'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import { useNavigate } from 'react-router-dom'
import OSearch from 'components/reusable/OSearch'
import CustomSelect from 'components/reusable/CustomSelect'
import { statusOptions } from 'utils/constants'

function SubAdmin () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user, updatePageName } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'subadmin_manager') ?? {}
  const [setEditShowModal] = useState(false)
  const [viewShow, setViewShow] = useState(false)
  const [subAdmin, setSubAdmin] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [isDelete, setIsDelete] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [filterData, setFilterData] = useState({
    category: '',
    searchkey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true)
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchkey: debouncedSearchTerm ? debouncedSearchTerm : '',
        isFilter: debouncedSearchTerm ? true : false
      })
      setPage(1)
    }
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])
  useEffect(() => {
    updatePageName(t('SUB_ADMIN_MANAGERS'))
  }, [])

  const allSubAdmin = async data => {
    try {
      const { category, startDate, endDate, searchkey, isFilter } = filterData
      if (
        (data?.deletePage && subAdmin?.length >= 1) ||
        (isFilter && category && data?.statusChange && subAdmin?.length >= 1)
      ) {
        setPage(page - 1)
        setIsDelete(true)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      } else {
        setIsDelete(false)
      }

      const payload = {
        page,
        pageSize: pageSize,
        status: category,
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchkey,
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }

      const path = apiPath.getsubadmin
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setSubAdmin(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    } catch (error) {
      console.log('error in get all sub admin list==>>>>', error.message)
    }
  }
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  const handelEdit = items => {
    setItem(items)
    setEditShowModal(true)
  }

  const handleUserView = items => {
    setItem(items)
    setViewShow(true)
  }

  useEffect(() => {
    allSubAdmin()
  }, [filterData, page, sort])

  const handleReset = () => {
    setFilterData({
      category: '',
      searchkey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }
  const statusPage = e => {
    setPage(1)
    setFilterData({ ...filterData, category: e.target.value, isFilter: true })
  }

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='2xl:flex border-b border-b-[#E3E3E3] gap-2 px-4 py-3'>
              <div className='items-center col-span-2 flex flex-wrap'>
                <div className='flex-wrap flex items-center lg:pt-0 pt-3 justify-center mb-2 2xl:mb-0'>
                  <div className='mb-3 relative flex items-center '>
                    <OSearch
                      placeholder={t('SEARCH_BY_SUB_ADMIN_NAME_ID')}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                  <ODateRangePicker
                    setIsReset={setFilterData}
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                  />
                  <CustomSelect
                    onChange={statusPage}
                    options={statusOptions}
                    placeholder='O_ALL'
                    t={t}
                    id='category'
                    name='category'
                    value={filterData.category}
                  />

                  <button
                    onClick={handleReset}
                    type='button'
                    className='ml-3 mb-3 py-2 bg-LightBlue text-sm px-8 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>
                </div>
              </div>
              <div className='ms-auto mb-3 flex items-center justify-end px-4 '>
                {(manager?.add || user?.role === 'admin') && (
                  <button
                    className='rounded-lg items-center bg-LightBlue flex text-sm px-8 ml-3 py-2 border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                    onClick={() => navigate('/sub-admin-manager/add')}
                    title={t('ADD_SUB_ADMIN')}
                    type='button'
                  >
                    + {t('ADD_SUB_ADMIN')}
                  </button>
                )}
              </div>
            </form>
            <SubTable
              subAdmin={subAdmin}
              handelEdit={handelEdit}
              allSubAdmin={allSubAdmin}
              handleUserView={handleUserView}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
      <>
        {viewShow ? (
          <SubAdminView setViewShow={setViewShow} item={item} />
        ) : null}
      </>
    </div>
  )
}

export default SubAdmin
